// 학생앱만의 판정 값. 규칙 로직은 shared(classify·shouldDrop)에 있고 여기엔 값만 둔다.

import {
  createNetworkSettleProbe,
  definePolicy,
  type ReportingPolicy,
} from '@mathflat/shared/@modules/errorReporting'

export const createStudentPolicy = (deps: {
  origin: string
  isOnline: () => boolean
  isNetworkUnsettled: () => boolean
}): ReportingPolicy =>
  definePolicy({
    bundleOrigins: [deps.origin],
    clientFaultCodes: [],
    expectedCodes: [],
    tokenRefreshRoutes: ['/v2/reissue'],
    resendingRoutes: ['/student-learning/time', '/daily-worksheet/learning-time'],
    isOffline: () => !deps.isOnline(),
    isNetworkUnsettled: deps.isNetworkUnsettled,
  })

export const studentPolicy = createStudentPolicy({
  origin: window.location.origin,
  isOnline: () => navigator.onLine,
  isNetworkUnsettled: createNetworkSettleProbe({ win: window, doc: document }),
})
